/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Inline, Col, Row, IconButton, Container,
  Typography,
  Link,
} from '@airbus/components-react';
import { LiveHelp, ViewComfyOutline, ViewModuleOutline } from '@airbus/icons/react';
import React from 'react';
import './Fleet.scss';
import { useAppDispatch, useAppSelector } from '../../store/hooksTypes';
import { setHelpModelToggle } from '../../models/helpModel/helpModelSlice';
import FleetInfiniteComponent from './FleetInfiniteComponent';
import SummaryModal from './SummaryModal';
import Loader from '../Shared/Loader/Loader';
import { setFleetState } from '../../models/checkerFleetModel/checkerFleetSlice';
import {
  DATA_WARNING_TEXT,
  NO_PREVIOUS_RECORDS_FOUND, NO_TABLE_RECORDS_FOUND, UPLOAD_FILE_NOW, USER_SCOPE_NSWC,
} from '../../utils/constants';
import { nswcFliUrlLink } from '../../utils/commonUtil';

const Fleet: React.FC = function Fleet() {
  const [showSummaryModal, setShowSummaryModal] = React.useState(false);
  const checkerFleetState = useAppSelector((state) => state.checkerFleet);
  const checkerDetailState = useAppSelector((state) => state.displayCheckerDetailsTable);
  const userPermissions = useAppSelector((state) => state.authEntrySlice);
  const featureToggleConfig = useAppSelector((state) => state.featureToggleDetails?.data);
  const featureToggle = featureToggleConfig?.airnavx_no_fin === 'true';
  const featureToggleFalse = featureToggleConfig?.airnavx_no_fin === 'false';
  const dispatch = useAppDispatch();

  const cardDataLoad = () => {
    if (checkerFleetState.visibleData.length === 0 && checkerFleetState.isFilterOperatorLoading === false && userPermissions?.userScope !== USER_SCOPE_NSWC) {
      return (
        <Typography className="no-data-text" data-testid="no-checker-data">
          {NO_TABLE_RECORDS_FOUND}
        </Typography>
      );
    }
    if (featureToggleConfig?.nswc === 'true' && userPermissions?.userScope === USER_SCOPE_NSWC && checkerFleetState.visibleData.length === 0) {
      return (
        <Container className="nswc-container">
          <Typography variant="medium" data-testid="nswc-text" className="nswc-text">{NO_PREVIOUS_RECORDS_FOUND}</Typography>
          <Link
            variant="underlined"
            title="Upload file now"
            className="nswc-link"
            onClick={nswcFliUrlLink}
            data-testid="nswc-fli-link"
            placeholder={undefined}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          >
            {UPLOAD_FILE_NOW}
          </Link>
        </Container>
      );
    }
    return <FleetInfiniteComponent checkerFleetState={checkerFleetState} checkerDetailState={checkerDetailState} featureToggle={featureToggle} />;
  };
  return (
    <>
      <Container>
        { featureToggleFalse && featureToggleConfig?.nswc === 'true' && userPermissions.userScope === USER_SCOPE_NSWC
          && (
            <Typography className="data-warning" variant="small">
              {DATA_WARNING_TEXT}
            </Typography>
          )}
        <Row>
          <Col className="fleet-container">
            {`Aircraft (${checkerFleetState.visibleData?.length})`}
            <LiveHelp className="fleet-help-icon" data-testid="filter-help-icon" onClick={() => { dispatch(setHelpModelToggle({ helpModalState: true, sourceOfHelpClick: featureToggle ? 'checkerFleetNcHelp' : 'checkerFleetHelp' })); }} />
          </Col>
          <Col className="icon-view">
            <Inline className="view-buttons" align="end">
              {featureToggleConfig?.smart_insights === 'true' && checkerFleetState?.visibleData[0]?.operator_code_icao === 'GFA' && (
              <IconButton
                className="fleet-gear-icon"
                variant="ghost"
                size="large"
                aria-label="Settings"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowSummaryModal(true);
                }}
                style={{ marginLeft: 8 }}
                placeholder={undefined}
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              >
                {/* GenAI Two Star SVG Icon (matching provided design) */}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 3.5C12.5 6 14 7.5 16.5 8C14 8.5 12.5 10 12 12.5C11.5 10 10 8.5 7.5 8C10 7.5 11.5 6 12 3.5Z" stroke="#222" strokeWidth="1.5" strokeLinejoin="round" />
                  <path d="M17.5 11C17.7 12 18.5 12.8 19.5 13C18.5 13.2 17.7 14 17.5 15C17.3 14 16.5 13.2 15.5 13C16.5 12.8 17.3 12 17.5 11Z" stroke="#222" strokeWidth="1.2" strokeLinejoin="round" />
                </svg>
              </IconButton>
              )}
              <IconButton className="large" variant="ghost" data-testid="large-view-button" onClick={() => dispatch(setFleetState({ selectedView: 'larger' }))} pressed={checkerFleetState.selectedView === 'larger'} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <ViewModuleOutline />
              </IconButton>
              <IconButton className="small" variant="ghost" data-testid="small-view-button" size="small" onClick={() => dispatch(setFleetState({ selectedView: 'smaller' }))} pressed={checkerFleetState.selectedView === 'smaller'} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <ViewComfyOutline />
              </IconButton>
            </Inline>
          </Col>
        </Row>
      </Container>
      <Container>
        {checkerFleetState.isDataLoading ? (
          <Loader isBlocking={checkerFleetState.isDataLoading} />
        ) : (
          cardDataLoad()
        )}
        {showSummaryModal && checkerFleetState?.visibleData[0]?.operator_code_icao === 'GFA' && (
          <SummaryModal
            open
            onClose={() => setShowSummaryModal(false)}
            checkerFleetState={checkerFleetState}
            checkerDetailState={checkerDetailState}
          />
        )}
      </Container>
    </>
  );
};
export default Fleet;
